module.exports = __webpack_public_path__ + "img/JC_lip.3781846f.png";